
// src/web/components/diary.jsx

import _ from 'lodash'
import React from 'react'
import PureComponent from '../../helpers/pure-component'
import { themr } from 'react-css-themr'
import diaryTheme from './themes/diary.css'
import connect from '../../connects/diary'
import {
  Card,
  CardMedia,
  CardTitle,
  CardText,
  CardActions
} from 'react-toolbox/lib/card'
import {
  Button,
  IconButton,
} from 'react-toolbox/lib/button'
import FontIcon from 'react-toolbox/lib/font_icon'
import CardTitleRightActions from './card-title-right-actions'
import { InviewSensor } from './infinite-scroller'

import DiaryTitle from './diary-title.jsx'
import DiaryDropdownMenu from './diary-dropdown-menu.jsx'

import DiaryTimestamp from './diary-timestamp.jsx'
import DiaryUser from './diary-user.jsx'
import DiaryLikes from './diary-likes.jsx'
import DiaryReaders from './diary-readers.jsx'
import DiaryMentionsBy from './diary-mentions-by.jsx'
import DiaryMentionsTo from './diary-mentions-to.jsx'
import DiaryActions from './diary-actions.jsx'
import DiaryCommentCount from './diary-comment-count.jsx'
import DiaryReportGraph from './diary-report-graph.jsx'
import DiaryReportActiveUserBar from './diary-report-active-user-bar.jsx'

import DiaryKPI from './diary-kpi.jsx'
import DiaryContent from './diary-content.jsx'
import DiaryAttachments from './diary-attachments.jsx'
import DiaryFields from './diary-fields.jsx'

import DiaryComment from './diary-comment.jsx'
import DiaryCommentForm from './diary-comment-form.jsx'

import DiaryV2ProgressChart from './diary-v2-progress-chart.jsx'
import DiaryCalendarData from './diary-calendar-data.jsx'

import ConfirmDialog from './confirm-dialog.jsx'
import ToggleButton from './toggle-button.jsx'
import ReviewCard from './review-card.jsx'

import i18next from '../../i18n'
import moment from 'moment'
import diaryButtonTheme from './themes/diary-form-button.css'
import iconTheme from './themes/user-icon.css'
import NewBadge from './new-badge.jsx'
import emoji from '../../native/assets/emoji'
import { urlRegex } from '../../helpers/url-regexp'

const DEFAULT_COMMENT_DISPLAY_COUNT = 3

const assets = {
  icons: {
    success: require('../../assets/stamps/gamba-kun-yattaze.png'),
  }
};

function TimelineUserIcon(props) {
  const {
    diary
  } = props

  return (
    <div className='newBadgeField' theme={iconTheme} >
      <img className='newBadgeIcon'  src={diary.user.icon_image.thumb_url}/>
      <NewBadge created_at={diary.user.created_at}/>
    </div>)
}
function TimelineReportIcon(props) {
  const {
    diary
  } = props

  return (
    <div className='newBadgeField' theme={iconTheme} >
      <img className='reportUserIcon'  src={assets.icons.success}/>
      <NewBadge created_at={diary.user.created_at}/>
    </div>)
}

@themr('Diary', diaryTheme)
class Diary extends PureComponent {
  state = { translated: undefined }
  onDeleteConfirm = ()=> this.setState({ deleteConfirm: true })
  onStamp = ()=> {
    const parent = this.props.diary
    this.props.showStampPalette((code)=> this.props.submitStamp(code, { parent }))
  }
  onComment = ()=> this.setState({ showCommentForm: true })
  onCommentClose = ()=> this.setState({ showCommentForm: false })
  showAllComments = ()=> this.setState({ showAllComments: !this.state.showAllComments })
  showAllKpis = ()=> this.setState({ showAllKpis: !this.state.showAllKpis })
  onDeleteConfirmYes = ()=> { this.setState({ deleteConfirm: false}); this.props.deleteDiary() }
  onDeleteConfirmNo = ()=> this.setState({ deleteConfirm: false })
  readDiary = _.throttle((visible)=> visible && this.props.readDiary(), 1000)
  onUnBlockConfirm = ()=> this.setState({ unblockConfirm: true })
  onUnBlockConfirmYes = ()=> { this.setState({ unblockConfirm: false}); this.props.updateBlockDiary(this.props.diary, false) }
  onUnBlockConfirmNo = ()=> this.setState({ unblockConfirm: false })

  UNSAFE_componentWillMount() {
    const lang = i18next.language
    const attach_json = this.props.diary.attach_json && typeof this.props.diary.attach_json == 'string' && JSON.parse(this.props.diary.attach_json) || this.props.diary.attach_json
    const translated = attach_json && attach_json.translations && attach_json.translations[lang] || undefined
    if (translated)
      this.setState({ translated })
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const lang = i18next.language
    const attach_json = this.props.diary.attach_json && typeof this.props.diary.attach_json == 'string' && JSON.parse(this.props.diary.attach_json) || this.props.diary.attach_json
    const next_attach_json = nextProps.diary.attach_json && typeof nextProps.diary.attach_json == 'string' && JSON.parse(nextProps.diary.attach_json) || nextProps.diary.attach_json
    const translated = attach_json && attach_json.translations && attach_json.translations[lang] || undefined
    const nextTranslated = next_attach_json && next_attach_json.translations && next_attach_json.translations[lang] || undefined
    if (translated != nextTranslated && nextTranslated)
      this.setState({ translated: nextTranslated })
  }

  onShowTranslate = ()=> {
    const lang = i18next.language
    const attach_json = this.props.diary.attach_json && typeof this.props.diary.attach_json == 'string' && JSON.parse(this.props.diary.attach_json) || this.props.diary.attach_json
    const translated = attach_json && attach_json.translations && attach_json.translations[lang] || undefined
    if (translated)
      this.setState({ translated })
    else
      this.props.translateDiary()
  }
  onShowOriginal = ()=> {
    this.setState({ translated: undefined })
  }

  onSendChatGPT = () => {
    this.props.askGpt(this.props.diary.content)
  }

  onOpenReview = ()=> {
    this.props.onOpenReview()
    this.props.setReviewTarget(this.props.diary.diary_id)
  }
  onCloseReview = ()=> {
    this.props.onCloseReview()
    this.props.setReviewTarget(undefined)
  }
  render() {
    const {
      t,
      theme,
      diary,
      searchHits,
      user,
      isPhone,
      deleteDiary,
      editDiary,
      likeDiary,
      reactionDiary,
      unlikeDiary,
      pinDiary,
      unpinDiary,
      pickupDiary,
      readDiary,
      showGroup,
      showUser,
      showReaders,
      showAttachments,
      isPickup,
      isLikeFetching,
      access_token,
      isAttachment,
      showStampPalette,
      translateDiary,
      isShowAllComments,
      onReplyScrollFrom,
      openSidePage,
      likeConfig,
      showImagesView,
      updateBlockDiary,
      blockUser,
      blockDiary,
      isBlockDisable,
      review,
      isFetching,
      isFetchFailed,
      reviewTarget,
      isReviewCompleted,
      query,
      isReviewEnable,
      isReviewButtonDisplay, 
      isShowTimeStamp,
    } = this.props
    
    var group = this.props.group || diary.group
    const myself =  diary && diary.user && diary.user.user_id == user.user_id
    const like = diary.likes && _.find(diary.likes, (like)=> like.user.user_id == user.user_id)
    const pin = diary.pin
    const read = diary.user.user_id == user.user_id || diary.readers && _.find(diary.readers, (reader)=> reader.user.user_id == user.user_id)
    const attach_json = diary.attach_json && typeof diary.attach_json == 'string' && JSON.parse(diary.attach_json) || diary.attach_json
    const kpiDisplayCount = openSidePage ? 2 : 4

    //ブロックされたユーザ・投稿の場合は中身を表示しないように
    if(!isBlockDisable && (blockUser || blockDiary))
      return <div></div>

    let timeLineIcon = null
    let showUserAction = null
    let diaryUserName = null
    let isReportDiary = false
    if (diary.category === 'report') {
      timeLineIcon = <TimelineReportIcon diary={diary} />
      diaryUserName = <span style={{fontSize: '14px', fontWeight: 'bold', color: '#000000', marginLeft: 3}}>gamba!</span>
      isReportDiary = true;
    } else {
      timeLineIcon = <TimelineUserIcon diary={diary}/>
      showUserAction = showUser
      diaryUserName = <DiaryUser key="user" user={diary.user} showUser={showUserAction} />
    }

    return (
      <Card theme={theme}>
        {pin &&
          <div style={{ marginTop: 15, marginLeft: 15 }}>
            <img src={emoji["1f4cc-pin"]} style={{ width: 25, height: 25, verticalAlign: 'top' }} />
            <span style={{ fontSize: 16.5, marginLeft: 8, fontWeight: 'bold' }}>{t('label:ピン留めされた投稿')}</span>
          </div>
        }
        {blockDiary && <div style={{ marginTop: 8 }}>
          <span style={{ marginLeft: 16 }}>
            <FontIcon value='info' style={{ color: 'gray', fontSize: 12 }} />
          </span>
          <span style={{ fontSize: 11, marginLeft: 8, color: 'gray' }}>{t('label:投稿ブロックされています')}</span>
        </div>}
        <CardTitleRightActions
          avatar={timeLineIcon}
          onAvatarClick={showUserAction}
          title={<DiaryTitle diary={diary} showGroup={showGroup} unread={!read}/>}
          subtitle={[
              diaryUserName,
              isShowTimeStamp ? <DiaryTimestamp key="timestamp" timestamp={diary.created_at} updated={diary.updated_at} />: null,
              <span key="span" style={{ fontSize: '12px' }}>{this.state.translated ? t('label:翻訳') : ''}</span>
            ]}
          rightActions={[
            <DiaryDropdownMenu key="dropdown" diary={diary}
              access_token={access_token}
              group={group}
              user={user}
              translated={this.state.translated}
              onShowTranslate={this.onShowTranslate}
              onShowOriginal={this.onShowOriginal}
              deleteDiary={this.onDeleteConfirm}
              editDiary={editDiary}
              pin={pin}
              onPin={pin ? unpinDiary : pinDiary}
              updateBlockDiary={updateBlockDiary}
              onUnBlockConfirm={this.onUnBlockConfirm}
              blockDiary={blockDiary} />,
            (!isPhone && !isPickup) && <IconButton key="pickup" icon='arrow_forward' onClick={pickupDiary} />
          ]} />

        {attach_json && attach_json.kpi_status &&
          <CardText theme={theme}>
          {_.map(attach_json.kpi_status.slice(0, !this.state.showAllKpis ? kpiDisplayCount : attach_json.kpi_status.length), (kpi)=>
            <DiaryKPI kpi={kpi} group={group} key={kpi.kpi_id} showAllKpis={this.state.showAllKpis}/>
          )}
          </CardText>
        }

        {attach_json && attach_json.kpi_status && attach_json.kpi_status.length > kpiDisplayCount &&
          <CardText theme={theme} >
            <ToggleButton
                flag={!this.state.showAllKpis}
                className="fluid"
                trueLabel={`${t('label:他n件のKPIをすべて表示', { n: attach_json.kpi_status.length - kpiDisplayCount })}`}
                falseLabel={t('label:隠す')}
                onClick={this.showAllKpis} />
          </CardText>
        }
        <DiaryV2ProgressChart attach_json={attach_json} />

        <DiaryContent content={this.state.translated || diary.content} isPhone={isPhone} searchHits={searchHits} urlLinks={attach_json && attach_json.links} />
        <DiaryFields fields={attach_json && attach_json.fields} query={query} />
        <DiaryCalendarData attach_json={attach_json} />
        <DiaryAttachments diary_id={diary.diary_id} files={diary.files} showAttachments={showAttachments} showImagesView={showImagesView}/>
        <DiaryReportActiveUserBar attach_json={attach_json} group={group} diary={diary} lang={this.props.i18n.language}/>
        <DiaryReportGraph user={user} diary={diary} group={group} attach_json={attach_json} />
        <CardText theme={theme} className="interaction">
          <DiaryLikes key="likes" myself={myself} likes={diary.likes} showReaders={showReaders} likes_count={diary.likes_count} likeConfig={likeConfig}/>
          <DiaryCommentCount key="comments" myself={myself} comments={diary.comments} showReaders={showReaders} />
          <DiaryMentionsBy key="mentions" mentions={diary.mentions} showReaders={showReaders} />
          <DiaryMentionsTo key="mention_users" mentions={diary.mention_users} showReaders={showReaders} />
          <DiaryReaders key="readers" myself={myself} readers={diary.readers} showReaders={showReaders} readers_count={diary.readers_count} />
        </CardText>
        {diary.diary_id == reviewTarget && this.props.isOpenReviewPanel && <ReviewCard t={t} theme={theme} isReviewCompleted={isReviewCompleted} onSendChatGPT={this.onSendChatGPT} onCloseReview={this.onCloseReview} review={review} isFetching={isFetching} isFetchFailed={isFetchFailed} />}
        {likeConfig &&
        <DiaryActions
            like={like}
            onLike={!isLikeFetching && (like && unlikeDiary || likeDiary) || undefined}
            onReaction={reactionDiary}
            onComment={this.onComment}
            onStamp={this.onStamp}
            onOpenReview={this.onOpenReview}
            isFetching={isFetching}
            isReviewEnable={isReviewEnable && !isReportDiary}
            isReviewButtonDisplay={isReviewButtonDisplay}
            isComment={false}
            likeConfig={likeConfig}/>}
        {!isShowAllComments && diary.comments && diary.comments.length > 3 &&
          <CardText theme={theme} >
            <ToggleButton
                flag={!this.state.showAllComments}
                className="fluid"
                trueLabel={`${t('label:件のコメントをすべて表示', { count: diary.comments.length - DEFAULT_COMMENT_DISPLAY_COUNT })}`}
                falseLabel={t('label:コメントを隠す')}
                isAttachment={ !this.state.showAllComments ? isAttachment : undefined}
                onClick={this.showAllComments} />
          </CardText>
        }

        {this.state.showCommentForm &&
          <DiaryCommentForm
              diary={diary}
              group={group}
              user={user}
              parent={diary}
              onClose={this.onCommentClose} />
        }

        {diary.comments && diary.comments.length > 0 &&
          _.map(diary.comments.slice((this.state.showAllComments || isShowAllComments) ? 0 : -3), (comment, i)=>
            <DiaryComment key={comment.comment_id}
              user={user}
              group={group}
              diary={diary}
              comment={comment}
              onReplyScrollFrom={onReplyScrollFrom}
              searchHits={searchHits}
              cont={comment.comment_id != diary.comments[diary.comments.length - 1].comment_id}
              isComment={true}
              isShowAllComments={isShowAllComments}
              likeConfig={likeConfig}/>
        )}

        {!read && <InviewSensor onChange={this.readDiary} />}

        <ConfirmDialog open={this.state.deleteConfirm}
            title={t('label:日報を削除してもいいですか')}
            description={t('label:この操作は取り消せません')}
            yesLabel={t('label:削除')}
            noLabel={t('label:取り消し')}
            onYes={this.onDeleteConfirmYes}
            onNo={this.onDeleteConfirmNo} />
        <ConfirmDialog key={'confirm'+user.user_id}
                  title={t('label:投稿のブロック解除')}
                  description={t('label:投稿のブロック解除説明')}
                  open={this.state.unblockConfirm}
                  onYes={this.onUnBlockConfirmYes}
                  onNo={this.onUnBlockConfirmNo}
                  yesLabel={t('label:ブロック解除')}
                  noLabel={t('label:取り消し')} />
      </Card>
    )
  }
}

export const RawDiary = Diary
export default connect(Diary)



// WEBPACK FOOTER //
// ./src/web/components/diary.jsx